import { SENSORS_API } from "@/config/apis.js";
import axios from "axios";

const _basicHeaders = {
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS"
};

const getBuoysFromPoint = async point => {
  /* Get buoys from closest to farest */
  const url = `${SENSORS_API.url}/Buoys?lon=${point.lon}&lat=${point.lat}`;

  const res = await axios.get(url, {
    headers: _basicHeaders
  });
  return res.data;
};

const getBuoyLastMeasure = async buoyId => {
  const url = `${SENSORS_API.url}/Buoys/${buoyId}/LatestData`;

  const res = await axios.get(url, {
    headers: _basicHeaders
  });
  return res.data;
};

const getVariablesFromBuoy = async buoyId => {
  const url = `${SENSORS_API.url}/Buoys/${buoyId}/Variables`;
  const res = await axios.get(url, {
    headers: _basicHeaders
  });
  return res.data;
};

export { getBuoysFromPoint, getBuoyLastMeasure, getVariablesFromBuoy };
